module.exports = __webpack_public_path__ + "static/media/intro-3.5980209a.png";